<template>
  <div class="text-center">
    <h5>IMAGES</h5>

    <ThumbnailImage
      v-for="image in images"
      :key="image.id"
      :image="image"
      :selected="
        image.id ==
        (externalSelectedId !== undefined
          ? externalSelectedId
          : internalSelectedId)
      "
      @click="onClick"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from "vue";
import ThumbnailImage from "@/components/ThumbnailImage.vue";

interface Image {
  id: number | string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

interface Props {
  images: Image[];
  selectedId?: number | string;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: "onImageSelected", id: number | string): void;
}>();

const internalSelectedId = ref<number | string>(0);
const externalSelectedId = computed(() => props.selectedId);

watch(externalSelectedId, (newVal) => {
  if (newVal !== undefined) {
    internalSelectedId.value = newVal;
  }
});

function onClick(id: number | string): void {
  internalSelectedId.value = id;
  emit("onImageSelected", id);
}
</script>
